export default __webpack_public_path__ + "static/media/client-18.5beadf46.png";